module.exports = __webpack_public_path__ + "static/media/blue_button1.d4084461.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blue_button1.png
// module id = 48
// module chunks = 0